/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import usePagination from 'src/hooks/usePagination';
import { useTenantContext } from 'src/components/TenantProvider';
import ProductsQuery from 'src/queries/ProductsQuery';
import ProductGridLoadingState from 'src/components/ProductGridLoadingState';
import { Banner, Link } from '@shopify/polaris';
import BannerMessages from 'src/components/BannerMessages';
import ProductGrid from 'src/components/ProductGrid';
import styleConstants from 'src/styles/constants';

const ProductGridContainer = () => {
  const { session } = useTenantContext();
  const {
    data,
    loading,
    error,
    allLoaded,
    refetch,
    loadingMore,
    loadMore,
    hasNextToken,
  } = usePagination({
    sessionId: session.id,
    query: ProductsQuery,
    type: 'products',
  });
  const flags = useFlags();

  const hasProducts = data && data.products.items.length > 0;

  const renderDowntimeBanner = () => {
    if (flags.featureDowntimeBanner) {
      return (
        <>
          <Banner status="warning">
            <p>
              This service is currently unavailable due to some routine
              maintenance we are performing to improve our systems.{' '}
              <Link
                url="https://status.thinkific.com/incidents/wqc25rly4tbl"
                external
              >
                Learn more
              </Link>
            </p>
          </Banner>
          <style jsx>{`
            :global(.Polaris-Banner) {
              margin-bottom: ${styleConstants.spacing.four};
            }
          `}</style>
        </>
      );
    }
    return null;
  };

  if (error) {
    const errorMessage = error.message.replace('GraphQL error:', '').trim();
    return <BannerMessages message={errorMessage} />;
  }

  if (loading || !hasProducts) {
    return (
      <>
        {renderDowntimeBanner()}
        <ProductGridLoadingState />
      </>
    );
  }

  return (
    <>
      {renderDowntimeBanner()}
      <ProductGrid
        handleListProductMutation={refetch}
        hasNextToken={hasNextToken}
        isFinishedLoading={allLoaded}
        isLoadingMore={loadingMore}
        products={data.products.items}
        onLoadMore={loadMore}
      />
    </>
  );
};

export default ProductGridContainer;
